/* eslint-disable no-use-before-define */
import React from 'react'
import { arrayToggle, Fields, arrayFrom, getState } from '../../../twd/twd'

const state = getState('corporates.use-search-company')

export default ({selected, setSelected} = {}) => {
    const [text, setText] = React.useState('')
    const [searchResults, setSearchResults] = React.useState([])

    React.useEffect(() => {
        let a = getCompanies({text, selected})
        setSearchResults(a)
    }, [text, selected])


    const isAll = selected.length === arrayFrom(state.value.companies).length

    return <React.Fragment>
    <Fields.Search
        dataName="corporates-market-news-holding-search-company"
        placeholder={ isAll ? 'All' : 'Selected' }
        type="select"
        onSelect={(a) => {
            let arr = a.value==='*'
                ? (isAll ? [] : [...searchResults])
                : arrayToggle([...selected], (b) => isEq(a,b), a)

            setSelected([...arr])
        }}
    >
    {({keyword : text}) => {
        setText(text)

        return <React.Fragment>
        { searchResults.length>1 && <React.Fragment>
            <Fields.SearchOption
                dataName="corporates-market-news-holding-search-company-select-all"
                item={{value:'*'}}>
            <Fields.CheckboxLabel
                dataName="corporates-market-news-holding-search-company-select-all-label"
                checked={isAll}
                label="Select all" />
            </Fields.SearchOption>
            <hr aria-hidden="true" />
        </React.Fragment>}
        {
            searchResults.map((a,i) => (
                <Fields.SearchOption
                    dataName="corporates-market-news-holding-search-company"
                    item={a}
                    key={i}>
                <Fields.CheckboxLabel
                    dataName="corporates-market-news-holding-search-company-label"
                    checked={a.selected}
                    label={a.label}
                    className="text-truncate"
                />
                </Fields.SearchOption>)
            )
        }
        </React.Fragment>

    }}
    </Fields.Search>
    </React.Fragment>
}



const getCompanies = ({text='', selected=[]} = {}) => {
    let t = text.toLowerCase()
    return arrayFrom(state.value.companies)
        .map(a => Object.assign({...a}, {
            selected: !!selected.find((b) => isEq(a,b))
        }))
        .filter(a => !text
            || a.label.toLowerCase().indexOf(t) >= 0)
}

const isEq = (a, b) => a.label === b.label


// WEBPACK FOOTER //
// ./src/corporates/market-news/holding-search/search-company.js